<template>
    <div class="teachingstatistics-classstatucs-table">
        <!-- 助学专业 -->
        <el-table
            v-if="type === 'major'"
            :data="tableData"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '14px',
            }"
        >
            <el-table-column label="序号" align="center" header-align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.rowNum }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="招生专业编码"
                prop="enrollMajorCode"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="专业名称"
                prop="majorName"
                align="center"
                header-align="center"
                width="140"
            >
                <template slot-scope="scope">
                    <div class="t_linkName" @click="handleSelected(scope.row)">
                        {{ scope.row.majorName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="专业代码"
                prop="majorCode"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="建设主考学校代码"
                prop="mainSchoolCode"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="专业建设主考学校"
                prop="mainSchoolName"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="课程组代码"
                prop="courseGroupCode"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="课程组名称"
                prop="courseGroupName"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="培养层次"
                prop="eduLevel"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{scope.row.eduLevel==='3'?'本科':scope.row.eduLevel==='4'?'专科':''}}
              </template>
            </el-table-column>
            <el-table-column
                label="授予学位"
                prop="degreeName"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="班级数"
                prop="albumCount"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="cursor: pointer; color: #d9001b">
                        {{ scope.row.albumCount }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="报名中"
                prop="signCount"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="cursor: pointer; color: #d9001b">
                        {{ scope.row.signCount }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="学习中"
                prop="learningCount"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="cursor: pointer; color: #4b7902">
                        {{ scope.row.learningCount }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="未开班"
                prop="noLearnCount"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="cursor: pointer; color: #409eff">
                        {{ scope.row.noLearnCount }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="已结课"
                prop="closeCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="在学人数"
                prop="stuLearnNum"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="学习总人数"
                prop="stuTotalNum"
                align="center"
                header-align="center"
            ></el-table-column>
        </el-table>
        <!-- 合作院校、合作机构 -->
        <el-table
            v-else
            :data="tableData"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '16px',
            }"
        >
            <el-table-column label="序号" align="center" header-align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.$index + 1 }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :label="type === 'school' ? '合作院校名称' : '合作机构名称'"
                :prop="type === 'school' ? 'schoolName' : 'mhmName'"
                align="center"
                header-align="center"
                show-overflow-tooltip

            >
                <template slot-scope="scope">
                    <div class="t_linkName"  @click="handleSelected(scope.row)">
                        {{
                            type === "school"
                                ? scope.row.schoolName
                                : scope.row.mhmName
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="开班总数"
                prop="albumCount"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="报名中"
                prop="signCount"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="学习中"
                prop="learningCount"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="未开始学习"
                prop="noLearnCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="已结束学习"
                prop="closeCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="在学人数"
                prop="stuLearnNum"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="学习总人数"
                prop="stuTotalNum"
                align="center"
                header-align="center"
            ></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: ["type", "tableData"],
    methods: {
      /** 选择专业查看 */
      handleSelected(row){
        this.$emit('changes',row)
      }
    },
};
</script>
<style lang="scss" scoped>
.teachingstatistics-classstatucs-table{
  .t_linkName{
    color: #409eff;
    cursor: pointer;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap
  }
}
</style>

